module.exports = __webpack_public_path__ + "static/media/Maven_6810.8577700e.jpg";